import type { Relations, RelationPosition } from "src/shared/api-types/course";
import type { UserProperty } from "src/shared/api-types/user";

export interface DisplayProperty {
  label: string;
  roleId: number;
  positionId: number;
  operationId?: number | null;
}

export interface DisplayOperation {
  id: number;
  name: string;
}

export interface DisplayPosition extends Omit<RelationPosition, "operations"> {
  operations: DisplayOperation[];
}

export interface DisplayRole {
  id: number;
  name: string;
  positions: DisplayPosition[];
}

const PropertiesService = {
  toDisplayObject(userProperties: UserProperty[], relations: Relations): DisplayProperty[] {
    return userProperties.map((property) => {
      const role = relations.roles.find((r) => r.id === property.roleId);
      const position = relations.positions.find((p) => p.id === property.positionId);
      const operation = relations.operations.find((o) => o.id === property.operationId);

      const label = [role?.name, position?.name, operation?.name].filter(Boolean).join(" - ");

      return {
        label,
        roleId: property.roleId,
        positionId: property.positionId,
        operationId: property.operationId,
      };
    });
  },

  relationsToDisplayObject(relations: Relations): DisplayRole[] {
    const roles = relations.roles.reduce<Record<number, DisplayRole>>((acc, val) => {
      acc[val.id] = {
        ...val,
        positions: relations.positions
          .filter((p) => p.roleId === val.id)
          .map((position) => {
            const operations = relations.operations.filter((op) => position.operations.includes(op.id));
            return { ...position, operations };
          }),
      };
      return acc;
    }, {});

    return Object.values(roles);
  },
};

export default PropertiesService;
